<template>
  <main-wrap :classes="classes" />
</template>

<script>
export default {
  name: 'main-app',
  props: {
    classes: {
      required: false,
      default: '',
      type: String
    }
  },
  asyncComponents: ['main-wrap']
}
</script>
<style type="text/css">

</style>
